<template>
  <div class='home'>
    <BankGroupList
      v-show='listView'
      @newBankGroup='onClickNewFromList'
      @editBankGroup='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <BankGroupForm
      v-show='formView'
      :bankGroup='bankGroup'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import BankGroupList from '@/components/bank-group/BankGroupList.vue'
import BankGroupForm from '@/components/bank-group/BankGroupForm.vue'

export default {
  name: 'Bank_Group',
  components: {
    BankGroupList,
    BankGroupForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      bankGroup: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.bankGroup = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.bankGroup = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.bankGroup = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
